import VGListener from "./src/vg";
import YaCounter from './src/modules/analytics/ym';

/**
 * DOM загружен
 */
document.addEventListener('DOMContentLoaded', function () {
	VGListener.onReady();
});

/**
 * Прокрутка окна
 */
window.addEventListener('scroll', function (event) {
	VGListener.onScroll(event);
});

/**
 * Изменение размера окна
 */
window.addEventListener('resize', function (event) {
	VGListener.onResize(event);
});

window.ymetrika = new YaCounter();

// [[vegas]]
